import React, { useMemo } from 'react';
import { BottomRightSection, BottomSection, Header, TopRightSection, TopSection, SubTitle } from './styles';
import { rootStore } from '../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { ICON_COLORS , PROJECT_ICON_TYPE } from '../../global/constants';
import AddIconDropdown from '../viewCard/addIconDropdown';
import ProjectIconAvatar from '../projectIconAvatar';
import { useMobileDevice } from '../../global/useMobile';
import { isEmpty } from '../../helpers/common';
import Image, { ImageKey } from '../image';

interface Props {
  subTitle?: string;
  title: string;
  isInbox?: boolean;
  noMargin?: boolean;
  applyDottedText?: boolean;
  removeTitleSpacing?: boolean;
  leftElement?: React.ReactNode;
  isProjectDetail?: boolean;
  isTemplatePreview?: boolean;
  isViewDetail?: boolean;
  image?: {
    url?: string | ImageKey;
    title?: string;
  };
}

const ResponsiveHeader: React.FC<Props> = ({
  subTitle,
  title,
  isInbox = false,
  noMargin = false,
  applyDottedText,
  removeTitleSpacing,
  leftElement,
  isProjectDetail = false,
  isTemplatePreview = false,
  isViewDetail = false,
  image
}) => {
  // other variables
  const isMobile = useMobileDevice();
  // Mobx variables
  const { projectStore, currentUser, appStore, workspaceStore, viewStore } = rootStore || {};
  const { currentProject, createProjectInput } = projectStore;
  const { currentView } = viewStore;
  const { isPageScrolled } = appStore || {};
  const { currentWorkspace: workspace } = workspaceStore;

  const projectIcon = useMemo(() => {
    return isTemplatePreview ? createProjectInput?.selectedTemplate?.icon : currentProject?.icon;
  }, [isTemplatePreview, createProjectInput?.selectedTemplate?.icon, currentProject?.icon]);

  return (
    <>
      <Header isInbox={isInbox} noMargin={noMargin}>
        <TopSection>
          <SubTitle>{isPageScrolled ? title : subTitle || workspace?.name}</SubTitle>
          {/* {!disableSubtitleUpdate ? (
          ) : (
            <SubTitle>{subTitle ? subTitle : workspace?.name}</SubTitle>
          )} */}
          {/* animation code for text transition  */}
          {/* <HeaderTexts>
            <AnimatedSubTitle className={isPageScrolled ? 'scrolled' : ''}>
              {subTitle || workspace?.name}
            </AnimatedSubTitle>
            <AnimatedTitle className={isPageScrolled ? 'scrolled' : ''}>{title}</AnimatedTitle>
          </HeaderTexts> */}
          <TopRightSection>{leftElement && leftElement}</TopRightSection>
        </TopSection>
      </Header>
      <BottomSection removeTitleSpacing={removeTitleSpacing} isInbox={isInbox} noMargin={noMargin}>
        {(isProjectDetail || isViewDetail) &&
          ((currentUser?.isAdmin || currentUser?.isOwner) && !isTemplatePreview && !isViewDetail ? (
            <AddIconDropdown
              currentProject={currentProject!}
              iconSize={isMobile ? 20 : 16}
              size={isMobile ? 32 : 26}
              fontSize={isMobile ? '20px' : '16px'}
            />
          ) : (
            <ProjectIconAvatar
              size={isMobile ? 32 : 26}
              type={
                isViewDetail
                  ? currentView?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT
                  : projectIcon?.type ?? PROJECT_ICON_TYPE.DEFAULT
              }
              reference={isViewDetail ? currentView?.icon?.reference || '' : projectIcon?.reference || ''}
              backgroundColor={
                isViewDetail
                  ? currentView?.icon?.color
                    ? ICON_COLORS[currentView?.icon?.color]
                    : ''
                  : projectIcon?.color
                  ? ICON_COLORS[projectIcon?.color]
                  : ''
              }
              projectName={
                isViewDetail
                  ? currentView?.name || ''
                  : isTemplatePreview
                  ? createProjectInput?.selectedTemplate?.name || ''
                  : currentProject?.name || ''
              }
              iconSize={isMobile ? 20 : 16}
              fontSize={isMobile ? '20px' : '16px'}
            />
          ))}
        {/* image section */}
        {!isEmpty(image?.url) && (
          <Image
            imageUrl={image?.url}
            alt={image?.title}
            width={32}
            height={32}
            borderRadius='var(--border-radius-6)'
          />
        )}
        <BottomRightSection applyDottedText={applyDottedText}>{title}</BottomRightSection>
      </BottomSection>
    </>
  );
};

export default observer(ResponsiveHeader);
